import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../components/reverse-search/Sidebar/Sidebar";
import AgentSidebar from "../../components/agent/AgentSidebar";
import { Avatar, Box, Button, CircularProgress, Drawer, Fab, IconButton, Input, InputBase, Paper, TextField, Tooltip, Typography } from "@mui/material";
import AnswerMessage from "../../components/reverse-search/Content/AnswerMessage";
import { toast } from "react-toastify";
import { publish } from "../../event/event";
import {
  API_BASE_URL,
  ROLE_USER,
  ROLE_ASSISTANT,
  ROLE_KNOWLEDGE,
  NGROK_URL,
} from "../../utils/const";
import ReactMarkdown from 'react-markdown';
import axios from "axios";
import { SysMessage } from "../../components/reverse-search/Content/SysMessage";
import SummarizedMsg from "../../components/reverse-search/Content/SummarizedMsg";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MenuIcon from '@mui/icons-material/Menu';
import { useSearchParams } from 'react-router-dom';
import trees from "../../tree.json";
import ChatContent from "../../components/agent/ChatContent";
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ChatInput from "../../components/agent/ChatInput";

const ChatbotDrawer = ({ selectedPaths, open, setOpen, initialMessage = null,selectedCalculator,prompt }) => {
  const [messages, setMessages] = useState([
    { type: 'bot', text: 'Ask anything about this calculator', timestamp: new Date() }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (initialMessage) {
      handleInitialMessage(initialMessage);
    }
  }, [initialMessage]);

  const handleInitialMessage = async (message) => {
    const userMessage = {
      type: 'user',
      text: message,
      timestamp: new Date()
    };
    setMessages(prevMessages => [...prevMessages, userMessage]);
    await handleBotResponse(message);
  };
  const CALCULATOR_KEY_MAP = {
    'simple-tax-calculator': 'simple tax calculator',
    'tax-withheld-calculator': 'tax withheld calculator',
    'income-tax-calculator': 'income tax estimator',
    'home-office-expenses-calculator': 'home office expenses calculator',
    'lodge-tax-return-calculator': 'do i need to lodge',
    'medical-levy-calculator': 'medicare levy calculator',
    'super-guarentee-calculator': 'super guarantee contributions',
    'resident-tax-calculator': 'tax residency',
    'determination-residency-calculator':'tax residency',
    'yoursuper-comparison-calculator': 'yourSuper comparison tool',
    'decision-7a-calculator': 'division 7a'
  }; 
  const handleBotResponse = async (message) => {
    console.log("selected calculator: ",selectedCalculator)
    console.log("selected calculator key: ",CALCULATOR_KEY_MAP[selectedCalculator])
    setIsLoading(true);
    try {
      const postData = {
       prompt: prompt,
        hierrachy: null,
        username: "user",
        learn: false,
        dataSource: "azureS",
        model: "gpt-4o",
        toolTip: false,
      legalInfo: false,
        fastSearch: null,
        helpGuides: false,
        calculator: CALCULATOR_KEY_MAP[selectedCalculator]||null,
      };

      await axios.post(`${API_BASE_URL}/chat/get-search-data`, postData);
      
    //   if (response.data && response.data.data) {
    //     let responseText = '';
    //     if (response.data.data.answer) {
    //       responseText = response.data.data.answer;
    //     } else if (response.data.data.text_search_document && response.data.data.text_search_document.length > 0) {
    //       responseText = `Based on my search, here's what I found: ${response.data.data.text_search_document[0].text}`;
    //     } else {
    //       responseText = "I couldn't find a specific answer to your question. Can you please rephrase it?";
    //     }

    //     const botMessage = {
    //       type: 'bot',
    //       text: responseText,
    //       timestamp: new Date(),
    //       sources: response.data.data.text_search_document || []
    //     };
        
    //     setMessages(prevMessages => [...prevMessages, botMessage]);
    //   }
    // } catch (error) {
    //   console.error('Error fetching response:', error);
    //   toast.error(`Error: ${error.message || 'Failed to get response'}`);
      
    //   const errorMessage = {
    //     type: 'bot',
    //     text: "I'm sorry, I encountered an error processing your request. Please try again.",
    //     timestamp: new Date(),
    //     isError: true
    //   };
      
    //   setMessages(prevMessages => [...prevMessages, errorMessage]);

    const streamPostData = {
      username: "user",
      prompt: prompt,
      // calculator:"income tax estimator",
      learn:false,
      // hierarchy: selectedPaths,
      // heirarchy: null,
      stream: true,
      calculator: CALCULATOR_KEY_MAP[selectedCalculator]||null,
    };

    const response = await fetch(`${API_BASE_URL}/chat/get-response-message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/event-stream",
        "Cache-Control": "no-cache",
        "Connection": "keep-alive",
      },
      body: JSON.stringify(streamPostData),
    });

    if (!response.ok) throw new Error("Error fetching stream response");
    setIsLoading(false);
    // Initialize empty bot message
    const initialBotMessage = {
      type: 'bot',
      text: '',
      timestamp: new Date(),
      sources: []
    };
    
    setMessages(prevMessages => [...prevMessages, initialBotMessage]);

    // Start reading the stream
    const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
    let accumulatedMessage = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      accumulatedMessage += value;

      // Update the bot message with accumulated text
      setMessages(prevMessages => {
        const newMessages = [...prevMessages];
        newMessages[newMessages.length - 1] = {
          ...newMessages[newMessages.length - 1],
          text: accumulatedMessage,
          timestamp: new Date()
        };
        return newMessages;
      });
    }

    // Get metadata from headers
    const chatId = response.headers.get("X-chat-Id");
    const metaInfo = response.headers.get("X-metainfo");
    const parsedMetaInfo = metaInfo ? JSON.parse(metaInfo) : {};

    // Final update with complete message and metadata
    setMessages(prevMessages => {
      const newMessages = [...prevMessages];
      newMessages[newMessages.length - 1] = {
        ...newMessages[newMessages.length - 1],
        text: accumulatedMessage,
        sources: parsedMetaInfo.text_search_document || [],
        timestamp: new Date(),
        id: chatId
      };
      return newMessages;
    });

  } catch (error) {
    console.error('Error fetching response:', error);
    toast.error(`Error: ${error.message || 'Failed to get response'}`);
    
    const errorMessage = {
      type: 'bot',
      text: "I'm sorry, I encountered an error processing your request. Please try again.",
      timestamp: new Date(),
      isError: true
    };
    
    setMessages(prevMessages => [...prevMessages, errorMessage]);
  } finally {
    setIsLoading(false);
  }

  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

 

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async () => {
    if (!inputMessage.trim()) return;

    const userMessage = {
      type: 'user',
      text: inputMessage.trim(),
      timestamp: new Date()
    };
    
    setMessages(prevMessages => [...prevMessages, userMessage]);
    setInputMessage('');
    setIsLoading(true);

    try {
      // First API call - get-search-data
      const searchPostData = {
        prompt: inputMessage.trim(),
        hierrachy: null,
        username: "user",
        learn: false,
        dataSource: "azureS",
        model: "gpt-4o",
        toolTip: false,
        legalInfo: false,
        fastSearch: null,
        helpGuides: false,
        calculator: CALCULATOR_KEY_MAP[selectedCalculator]||null,
      };
      console.log("selected calculator: ",selectedCalculator)
      console.log("selected calculator key: ",CALCULATOR_KEY_MAP[selectedCalculator])

      await axios.post(`${API_BASE_URL}/chat/get-search-data`, searchPostData);

      // Second API call - get-response-message with streaming
      const streamPostData = {
        username: "user",
        prompt: inputMessage.trim(),
        // calculator:"income tax estimator",
        learn:false,
        // hierarchy: selectedPaths,
        // heirarchy: null,
        stream: true,
        calculator: CALCULATOR_KEY_MAP[selectedCalculator]||null,
      };

      const response = await fetch(`${API_BASE_URL}/chat/get-response-message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/event-stream",
          "Cache-Control": "no-cache",
          "Connection": "keep-alive",
        },
        body: JSON.stringify(streamPostData),
      });

      if (!response.ok) throw new Error("Error fetching stream response");
      setIsLoading(false);
      // Initialize empty bot message
      const initialBotMessage = {
        type: 'bot',
        text: '',
        timestamp: new Date(),
        sources: []
      };
      
      setMessages(prevMessages => [...prevMessages, initialBotMessage]);

      // Start reading the stream
      const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
      let accumulatedMessage = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        accumulatedMessage += value;

        // Update the bot message with accumulated text
        setMessages(prevMessages => {
          const newMessages = [...prevMessages];
          newMessages[newMessages.length - 1] = {
            ...newMessages[newMessages.length - 1],
            text: accumulatedMessage,
            timestamp: new Date()
          };
          return newMessages;
        });
      }

      // Get metadata from headers
      const chatId = response.headers.get("X-chat-Id");
      const metaInfo = response.headers.get("X-metainfo");
      const parsedMetaInfo = metaInfo ? JSON.parse(metaInfo) : {};

      // Final update with complete message and metadata
      setMessages(prevMessages => {
        const newMessages = [...prevMessages];
        newMessages[newMessages.length - 1] = {
          ...newMessages[newMessages.length - 1],
          text: accumulatedMessage,
          sources: parsedMetaInfo.text_search_document || [],
          timestamp: new Date(),
          id: chatId
        };
        return newMessages;
      });

    } catch (error) {
      console.error('Error fetching response:', error);
      toast.error(`Error: ${error.message || 'Failed to get response'}`);
      
      const errorMessage = {
        type: 'bot',
        text: "I'm sorry, I encountered an error processing your request. Please try again.",
        timestamp: new Date(),
        isError: true
      };
      
      setMessages(prevMessages => [...prevMessages, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <Tooltip title="Chat Assistant" placement="left">
        <Fab
          color="primary"
          aria-label="chat"
          onClick={toggleDrawer}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000
          }}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      </Tooltip>

      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: '600px' },
            maxWidth: '100%'
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2,
              borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <SmartToyOutlinedIcon sx={{ mr: 1, color: 'primary.main' }} />
            </Box>
            <IconButton onClick={toggleDrawer} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            ref={chatContainerRef}
            sx={{
              flexGrow: 1,
              p: 2,
              overflowY: 'auto',
              bgcolor: '#f5f7f9',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {messages.map((message, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: message.type === 'user' ? 'row-reverse' : 'row',
                  mb: 2
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: message.type === 'user' ? 'primary.main' : 'secondary.light',
                    width: 32,
                    height: 32,
                    mt: 0.5
                  }}
                >
                  {message.type === 'user' ? <AccountCircleOutlinedIcon /> : <SmartToyOutlinedIcon />}
                </Avatar>
                <Box
                  sx={{
                    maxWidth: '75%',
                    mx: 1
                  }}
                >
                  <Paper
  elevation={1}
  sx={{
    p: 1.5,
    borderRadius: 2,
    bgcolor: message.type === 'user' ? 'primary.light' : 'background.paper',
    color: message.type === 'user' ? 'primary.contrastText' : 'text.primary',
    ...(message.isError ? { bgcolor: '#ffebee' } : {}),
    '& pre': {
      backgroundColor: '#f5f5f5',
      padding: '0.75rem',
      borderRadius: '4px',
      overflow: 'auto'
    },
    '& code': {
      backgroundColor: '#f5f5f5',
      padding: '0.2rem 0.4rem',
      borderRadius: '4px',
      fontSize: '0.875em'
    },
    '& a': {
      color: 'primary.main',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      margin: '1rem 0'
    },
    '& th, & td': {
      border: '1px solid rgba(0, 0, 0, 0.12)',
      padding: '0.5rem'
    },
    '& blockquote': {
      borderLeft: '4px solid rgba(0, 0, 0, 0.12)',
      margin: '0',
      paddingLeft: '1rem',
      color: 'text.secondary'
    }
  }}
>
  {message.type === 'user' ? (
    <Typography variant="body1">{message.text}</Typography>
  ) : (
    <ReactMarkdown>{message.text}</ReactMarkdown>
  )}
</Paper>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      display: 'block',
                      mt: 0.5,
                      textAlign: message.type === 'user' ? 'right' : 'left'
                    }}
                  >
                    {formatTime(message.timestamp)}
                  </Typography>
                </Box>
              </Box>
            ))}
            {isLoading && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 1.5,
                  alignSelf: 'flex-start',
                  maxWidth: '75%'
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: 'secondary.light',
                    width: 32,
                    height: 32,
                    mr: 1
                  }}
                >
                  <SmartToyOutlinedIcon />
                </Avatar>
                <CircularProgress size={20} thickness={4} sx={{ ml: 1 }} />
                <Typography variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
                  Thinking...
                </Typography>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              p: 2,
              borderTop: '1px solid rgba(0, 0, 0, 0.12)',
              bgcolor: 'background.paper'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Type your message..."
                value={inputMessage}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                multiline
                maxRows={4}
                disabled={isLoading}
                InputProps={{
                  sx: { borderRadius: 3, pr: 1 }
                }}
              />
              <IconButton
                color="primary"
                onClick={handleSendMessage}
                disabled={!inputMessage.trim() || isLoading}
                sx={{ ml: 1 }}
              >
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

const AgentPage = ({ container, setContainer, selectedPaths, setSelectedPaths,setSelectedText,hierarchy,setHierarchy,selectedIds,setSelectedIds }) => {
  const [chatContents, setChatContents] = useState([]);
  const containerRef = useRef(null);
  const textareaRef = useRef(null);
  const scrollRef = useRef(null);
  const [isThinking, setIsThinking] = useState(false);
  const [chatText, setChatText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [chatLists, setChatLists] = useState([]);
  const [currentKeywords, setCurrentKeywords] = useState("");
  const [queryText, setQueryText] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [searchResult, setSearchResult] = useState({});
  const [currentInput, setCurrentInput] = useState("");
  const [error, setError] = useState("");
  const [isWorking, setWorking] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const [selectedChat, setSelectedChat] = useState(null);
  const [initialChatMessage, setInitialChatMessage] = useState(null);
  const [selectedCalculator,setSelectedCalculator] = useState(null);
  const [prompt,setPrompt]=useState('')
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const [selectedReferences, setSelectedReferences] = useState({
    text_search_document: [],
    semantic_search_document: [],
    google_search_results: [],
    google_com_search_results: []
  });

  const handleInitialQuery = (query) => {
    setInitialChatMessage(query);
  };

  const updateQueryText = (keywordsArray) => {
    const query = keywordsArray.map(item => item.value).join(' ');
    setQueryText(query);
  };

  const handleChange = (e) => {
    setCurrentInput(e.target.value);
    setError("");
  };

  const newChatClicked = async () => {
    setChatContents([]);
    setSelectedReferences({
      text_search_document: [],
      semantic_search_document: [],
      google_com_search_results: [],
      google_search_results: []
    });

    await axios.post(`${API_BASE_URL}/chat/create-new-chat`).then((response) => {
      console.log("New chat created");
    });
  };

  useEffect(() => {
    console.log(selectedChat, "Selected Chat")
    if (!searchParams.get('chatId')) {
      newChatClicked()
    }
  }, []);

  const getNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      } else if (node.children && node.children.length) {
        const foundChild = getNodeById(node.children, id);
        if (foundChild) {
          return foundChild;
        }
      }
    }
    return null;
  };

  const getLabelTitle = (parent, title) =>
    parent && parent.length > 0 ? `${parent} > ${title}` : title;
  
  const reindexTree = (nodes, parents = [], path = "") => {
    return nodes.map((node, index) => {
      const currentId =
        parents && parents.length
          ? `${parents[parents.length - 1]}.${index + 1}`
          : `${index + 1}`;
      const newNode = {
        ...node,
        id: currentId,
        parents: parents,
        path: getLabelTitle(path, node.title),
      };
      const childParent = [...parents, currentId];
  
      if (node.children && node.children.length > 0) {
        newNode.children = reindexTree(node.children, childParent, newNode.path);
      }
      return newNode;
    });
  };
    const treeItems = reindexTree(trees);
  

    useEffect(() => {
      if (!hierarchy) {
        const parents = ["1", "2", "3", "15"];
        setSelectedIds([...parents]);
        const paths = parents.map((parent) => getNodeById(treeItems, parent).path);
        console.log(paths)
        setSelectedPaths([...paths]);
      }
      
    }, [hierarchy]);
  console.log(selectedReferences, "Reverences in Reverse Search");

  const tempFunction = () => {
    console.log("in temp function");
  };

  const getSummary = async (_url, title, source) => {
    setChatContents((prevComponents) => [
      ...prevComponents,
      <SysMessage
        key={`sysMessage1_${new Date().getTime()}`}
        initialStatus={true}
        chatMsg={"Summarizing '" + title + "' ..."}
      />,
    ]);
    const postData = { url: _url, title: title, dataSource: source == "weaviate" ? "ato" : source };
    await axios
      .post(`${API_BASE_URL}/reverse_search/get-summary`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <SummarizedMsg
              key={answerKey}
              answerMsg={{
                msg: response.data.summarization,
              }}
            />
          </React.Fragment>,
        ]);
      })
      .catch((error) => toast.error("Error fetching data:" + error))
      .finally(() => {
        publish("endLoading");
        hideSysMsgPromise();
      });
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/reverse_search/get-all-chats`).then((response) => {
      setChatLists(response.data.chats);
    });
  }, []);

  useEffect(() => {
    if (selectedChat || searchParams.get('chatId')) {
      loadChatContent(selectedChat || searchParams.get('chatId'));
    }
  }, [selectedChat]);

  const loadChatContent = async (chatId) => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${API_BASE_URL}/reverse_search/get-all-qa`, {
        chat_id: chatId
      });

      const messages = response.data.qa || [];
      const chatContentComponents = messages.map((message) => (
        <React.Fragment key={`chatContent_${message.id}_${new Date().getTime()}`}>
          {message.question && (
            <div className="chat-content-user">{message.question}</div>
          )}
          {message.answer && (
            <AnswerMessage
              answerMsg={{
                id: message.id,
                prompt: message.answer,
                metainfo: {
                  google_com_search_results: message.selected_search_results?.google_com_search_results || [],
                  google_search_results: message.selected_search_results?.google_search_results || [],
                  semantic_search_document: message.selected_search_results?.semantic_search_document || [],
                  text_search_document: message.selected_search_results?.text_search_document || []
                }
              }}
              setChatText={setChatText}
              setSelectedText={setSelectedText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
            />
          )}
        </React.Fragment>
      ));

      setChatContents(chatContentComponents);

      setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: 'smooth'
          });
        }
      }, 100);
    } catch (error) {
      toast.error("Error loading chat: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const setQuery = ($event) => {
    if (queryText != '') {
      setChatText(queryText);
      getResponseFromServer(queryText);
    }
  };

  const addKeyword = () => {
    if (!currentInput.trim()) {
      setError("Keyword cannot be empty");
      return;
    }

    setKeywords([...keywords, { type: 'keyword', value: currentInput.trim() }]);

    setCurrentInput("");

    updateQueryText([...keywords, { type: 'keyword', value: currentInput.trim() }]);
  };

  const clearQuery = () => {
    setKeywords([]);
    setCurrentInput("");
    setQueryText("");
    setError("");
  };

  const addOperator = (operator) => {
    if (keywords.length === 0) {
      setError("Cannot add operator without a keyword");
      return;
    }

    const lastItem = keywords[keywords.length - 1];
    if (lastItem.type === 'operator') {
      setError("Cannot add two operators consecutively");
      return;
    }

    setKeywords([...keywords, { type: 'operator', value: operator }]);

    updateQueryText([...keywords, { type: 'operator', value: operator }]);
  };

  const removeLastItem = () => {
    if (keywords.length > 0) {
      const updatedKeywords = keywords.slice(0, -1);
      setKeywords(updatedKeywords);
      updateQueryText(updatedKeywords);
    }
  };

  const hideSysMsgPromise = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    publish("hideSysMsg");
  };

  const getResponseForRef = (text) => {
    const postData = {
      prompt: text ?? "tax",
      username: "user",
      selected_search_results: selectedReferences,
      model: "gpt-4o",
    };
    setIsLoading(true);
    axios
      .post(`${API_BASE_URL}/reverse_search/get-query-response`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;
        console.log(response.data, "Response");

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <AnswerMessage
              key={answerKey}
              answerMsg={{
                id: response?.data?.data?.id,
                prompt: text,
                metainfo: response.data.data ? response?.data?.data : response?.data?.message
              }}
              setSelectedText={setSelectedText}
              setChatText={setChatText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
            />
          </React.Fragment>,
        ]);
        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTo({
              top: containerRef.current.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 100);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("Error fetching data:" + error);
      })
      .finally(() => {
        publish("endLoading");
        setIsThinking(false);
        setIsLoading(false);
        textareaRef.current.value = "";
      });
  };

  const getResponseFromServer = (text) => {
    setIsThinking(true);

    const postData = {
      prompt: queryText.replace(/\s*(&|\|\|)\s*/g, " "),
      keywordsadv: queryText,
      hierrachy: selectedPaths?.length == 0 ? ["ATO general website"] : selectedPaths,
    };

    axios
      .post(`${API_BASE_URL}/reverse_search/get-search-data`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;
        console.log(response.data, "Response");

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <AnswerMessage
              key={answerKey}
              answerMsg={{
                id: response.data.data.id,
                prompt: text,
                metainfo: response.data.data
              }}
              setChatText={setChatText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
              setSelectedText={setSelectedText}
              getSummary={getSummary}
            />
          </React.Fragment>,
        ]);

        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTo({
              top: containerRef.current.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 100);
      })
      .catch((error) => {
        toast.error("Error fetching data:" + error);
      })
      .finally(() => {
        publish("endLoading");
        setIsThinking(false);
      });
  };

  return (
    <>
      <div className="chat-container">
        <AgentSidebar
            setContainer={setContainer}
            container={container}
        />

        <div className="main-container reverse-container">
          <span
            style={{ textAlign: "center", width: "100%", marginTop: "35px" }}
          ></span>
          <ChatContent
            selectedCalculator={selectedCalculator}
            setSelectedCalculator={setSelectedCalculator}
            newChatCreated={newChatClicked}

          />
          <ChatbotDrawer 
            selectedPaths={selectedPaths} 
            open={open} 
            setOpen={setOpen}
            initialMessage={initialChatMessage}
            selectedCalculator={selectedCalculator}
            prompt={prompt}
          />
          <ChatInput 
            keywords={keywords} 
            setOpen={setOpen}
            handleInitialQuery={handleInitialQuery}
            containerRef={containerRef} 
            textareaRef={textareaRef} 
            isThinking={isLoading}
            setPrompt={setPrompt}
            selectedChat={selectedChat}
          />
        </div>
      </div>
    </>
  );
};

export default AgentPage;
